import React from 'react';
import '../NavigationTab.scss';
import { hasPermission } from '../../../utils/controller';

const NavigationTabMain = ({ activeTabMain, setActiveTabMain, user }) => {
	const navTabs = hasPermission('purchases.vendors.statement', user?.role?.role_permissions)
		? ['Information', 'Transactions', 'Statement']
		: ['Information', 'Transactions'];

	return (
		<div>
			<ul className="nav">
				{navTabs.map((item, index) => (
					<li
						key={index}
						className="nav-item"
					>
						<a
							className={`nav-link ${activeTabMain === item ? 'active' : ''} cursur-pointer`}
							href="#"
							onClick={() => setActiveTabMain(item)}
						>
							{item}
						</a>
					</li>
				))}
			</ul>
		</div>
	);
};

export default NavigationTabMain;
